<script>
    import { mapGetters } from 'vuex'
    import uiInput from '../daniel/ui-input.vue'
    export default {
        name: 'summaryAddress',
	    components: { uiInput },
        props: {
            readonly: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            ...mapGetters(['cartGetAddress'])
        }
    }
</script>

<template>
    <div id="summary-address">
        <h5>Domicilio para entrega</h5>
        <div class="mt-3">
            <b-row>
                <b-col cols="6">
                    <ui-input label="Calle" v-model="cartGetAddress.calle" :readonly="true"/>
                </b-col>
                <b-col>
                    <ui-input label="Numero" v-model="cartGetAddress.numero" :readonly="true"/>
                </b-col>
                <b-col>
                    <ui-input label="Numero interior" v-model="cartGetAddress.numero_interior" :readonly="true"/>
                </b-col>
            </b-row>

            <b-row>
                <b-col>
                    <ui-input label="Colonia" v-model="cartGetAddress.colonia" :readonly="true"/>
                </b-col>
                <b-col>
                    <ui-input label="CP:" v-model="cartGetAddress.codigo_postal" :readonly="true"/>
                </b-col>
            </b-row>
            
            
            <ui-input label="Referencia" v-model="cartGetAddress.referencia" type="textarea" :readonly="true"/>
            <!-- {{cartGetAddress}} -->
        </div>
    </div>
</template>